/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type ShareClassEnum = 'A' | 'B' | 'C' | '11184809';

export const ShareClassEnum = {
  A: 'A' as ShareClassEnum,
  B: 'B' as ShareClassEnum,
  C: 'C' as ShareClassEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as ShareClassEnum
};
